import { constants } from "../../../constants";

export default class KeepAlive {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.keepAlive();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.SLINGO:
                event["gameActivity"] = this._default;
                break;
            case constants.BGS:
                event["gameActivity"] = this._default;
                break;
            case constants.RGU:
                event["gameActivity"] = this._default;
                break;
            case constants.RAW:
                event["gameActivity"] = this._default;
                break;
            case constants.HB:
                event["gameActivity"] = this._default;
                break;
            case constants.EYE:
                event["busyStatus"] = this._default;
                break;
            default:
                event["keepAlive"] = this._default;
        }

        return event;
    }
}
